import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const APIHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50 pt-24 pb-16 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-6">
              <Icon name="Code2" size={16} />
              <span>Enterprise API v2.0</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Build Medical Policy Intelligence Into Your Platform
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0">
              Integrate PolicyAlerts' proven medical policy monitoring directly into your healthcare technology stack. Enterprise-grade API with 99.9% uptime and real-time policy updates.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button variant="default" size="lg" iconName="BookOpen" iconPosition="left">
                View Documentation
              </Button>
              <Button variant="outline" size="lg" iconName="Key" iconPosition="left">
                Get API Key
              </Button>
            </div>
            
            <div className="flex flex-wrap items-center gap-6 mt-8 justify-center lg:justify-start text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
                <span>RESTful & GraphQL</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
                <span>Webhook Support</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
                <span>99.9% Uptime SLA</span>
              </div>
            </div>
          </div>
          
          <div className="flex-1 w-full max-w-xl">
            <div className="bg-gray-900 rounded-lg shadow-2xl p-4 md:p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="flex gap-1.5">
                  <div className="w-3 h-3 rounded-full bg-red-500"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500"></div>
                </div>
                <span className="text-gray-400 text-xs ml-2">api-example.js</span>
              </div>
              <pre className="text-green-400 text-xs md:text-sm overflow-x-auto">
                <code>{`// Initialize PolicyAlerts API
const policyAlerts = require('@policyalerts/sdk');

const client = new policyAlerts.Client({
  apiKey: process.env.POLICY_ALERTS_KEY,
  environment: 'production'
});

// Monitor policy changes
const policies = await client.policies.list({
  category: 'cardiovascular',
  status: 'active',
  updatedAfter: '2026-01-01'
});

console.log(\`Found \${policies.length} policies\`);`}</code>
              </pre>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default APIHero;